const getInitials = (name) => {
  if (!name || typeof name !== "string") return "";

  return name
    .split(" ")
    .filter((part) => part.length > 0)
    .map((part) => part[0].toUpperCase())
    .join("");
};

export const tableSchema = {
  heights: { header1: "40px" },
  classes: { header1: "" },
  inlineBodyData: false,
  minDataRowsCount: 8,
  columns: [
    { title: "Task Steps", accessor: "taskstep", colSpan: 1, rowSpan: 1 },
    { title: "Hazard", accessor: "hazard", colSpan: 1, rowSpan: 1 },
    { title: "Control", accessor: "control", colSpan: 1, rowSpan: 1 },
  ],
};
export const workerSchema = {
  heights: { header1: "40px" },
  classes: { header1: "" },
  inlineBodyData: false,
  minDataRowsCount: 6,
  columns: [
    { title: "Worker Name: Print ", accessor: "name", colSpan: 4, rowSpan: 1 },
    { title: "Initial", accessor: "name", colSpan: 1, rowSpan: 1, formatter: (value) => getInitials(value) },
  ],
};



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/ETRReports/Schema.js